import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore-group/lib.helpers.resolve-props';

const getUserSettings = (state) => resolveProp('profile.data.userSettings', state);

export default createSelector(getUserSettings, (userSettings) => userSettings);
